@if (!isNavigating()) {
  <abp-card class="zn-crud-page">
    <abp-card-body>
      <app-crud-page
        #rootCrudPage
        [tableName]="getRootLocalizationKey()"
        [permission]="getRootConfig().permission"
        [fields]="getRootFields()"
        [dataset]="getRootDataset()"
        [loading]="getRootLoading()"
        [loadData]="rootLoadData()"
        [actions]="actions"
        [hideCreateButton]="hideCreateButton"
        [disableEdit]="disableEdit"
        [disableEditInline]="disableEditInline"
        [disableCanDelete]="disableCanDelete"
        [disableDuplicate]="disableDuplicate"
        (createRecord)="onRootCreate()"
        (deleteRecord)="onRootDelete()"
        (editRow)="onRootEdit($event)"
        (saveInMemoryRequested)="onRootSaveInMemory($event)"
        (selectedItemsChange)="onRootRowSelection($event)"
        [exportInProgress]="rootComponentInstance?.exporting?.() ?? false"
        (exportToExcelRecord)="onRootExportToExcel()"
      ></app-crud-page>
    </abp-card-body>
  </abp-card>
}

@else {
  @for (level of accordionLevels(); track level.entityName; let i = $index) {
    <zn-hierarchy-navigator
      class="hierarchy-accordion-animate"
      [style.animation-delay]="(i * 0.1) + 's'"
      [showFrame]="true"
      [parentTitle]="getLevelTitle(level)"
      [parentSummaryData]="level.selectedRow"
      [parentSummaryFields]="level.fields"
      [isExpanded]="!collapsedLevels().has(i)"
      [hierarchyLevel]="i + 1"
      (accordionTitleClick)="navigateBack(i - 1)"
      (accordionToggled)="onAccordionToggled(i, $event)"
    >
      <!-- enableInitialAutoQuery disabled to prevent double queries; filters are applied programmatically via applyAccordionParentFilter -->
      <app-generic-table
        [enableInitialAutoQuery]="false"
        [entityColumnDefinitions]="getAccordionColumns(level)"
        [dataSource]="getAccordionDataset(level)"
        [loading]="getAccordionLoading(level)"
        [backendServiceProcess]="level.componentInstance.loadData"
        [extraOptions]="{ editable: false, autoEdit: false, showHeaderRow: false, enableFiltering: true, gridHeight: 250, showFooterRow: false }"
        [showCheckboxColumn]="false"
        [showEditColumn]="false"
        [canEditInline]="false"
        (gridRowClick)="onAccordionRowClick(i, $event)"
        (initializationCompleted)="onAccordionGridReady(i, $event)"
        [exportInProgress]="level.componentInstance?.exporting?.() ?? false"
        (exportToExcelRecord)="onAccordionExportToExcel(i)"
        (technicalNamesReport)="onAccordionTechnicalNamesReport(i)"
      ></app-generic-table>
    </zn-hierarchy-navigator>

    @let tabs = getTabsForLevel(i);
    @if (tabs.length > 1) {
      <zn-tabs [activeTabName]="getActiveTabForLevel(i)" (tabChanged)="onTabChanged(i, $event)">
        @for (child of tabs; track child.entityName) {
          <zn-tab
            [name]="child.entityName"
            [title]="child.localizationKey | abpLocalization"
          >
          </zn-tab>
        }
      </zn-tabs>
    }
  }

  <abp-card class="hierarchy-child-table-animate zn-crud-page">
    <abp-card-body>
      <div #childComponentContainer class="child-component-container"></div>
    </abp-card-body>
  </abp-card>
}

<app-technical-names-report-modal
  [(isVisible)]="isTechnicalNamesModalOpen"
  [config]="technicalNamesModalConfig">
</app-technical-names-report-modal>
